import * as types from './types';

function setReviewFeedContent(data, reviewId) {
    return {
        meta: reviewId,
        payload: data,
        type: types.SET_REVIEW_FEED_CONTENT,
    };
}

export {
    setReviewFeedContent,
};

export default {
    setReviewFeedContent,
};
